import { Icon, SxProps } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

type Props = {
    icon: string,
    sx?: SxProps
}

function isLetter(str: string) {
    return str.length === 1 && str.match(/[a-z]/i);
}

const getIconWithCorrectCase = (iconName: string) => {
    let icon = '';

    for (var c = 0; c < iconName.length; c++) {
        var char = iconName[c];

        if (isLetter(char) && (char === char.toUpperCase() && c > 0)) {
            icon += '_'
        }

        icon += char.toLowerCase();
    }
    
    return icon;
}


const CustomIcon = ({ icon, sx }: Props) => {    
    if (!icon || icon.toLowerCase() === 'none') return null;
    
    if (getIconWithCorrectCase(icon) === "whats_app_icon") return <WhatsAppIcon sx={{ ...sx }} />


    return <Icon fontSize="small" sx={{ ...sx }}>{getIconWithCorrectCase(icon)}</Icon>
}

export { CustomIcon }
export default CustomIcon;